module.exports = __webpack_public_path__ + "media/images/countrysquared/cu-f5fd55e018eaca113fc0ba131099b227.svg";